import { createFileRoute } from "@tanstack/react-router";
import { legacyRedirectTo } from "@/lib/legacy-redirect";

// Legacy URL /destinations → redirect to /app/destinations.
export const Route = createFileRoute("/destinations/")({
  beforeLoad: legacyRedirectTo("/app/destinations"),
  component: () => null,
});
